import React from 'react';
import PublicReservation from '../PublicReservation/PublicReservation';

/**
 * 予約フォームプレビュー（スタッフ向け・/:store_id/reservation/preview）。
 * お客様に見える公開予約ページ（PublicReservation）を isPreview 付きでそのまま描画する方式
 * （MenuPreview と同型・feast-fe ADR 0030 踏襲）。isPreview では送信が無効化され、
 * 送信ボタン押下時はプレビューである旨の Snackbar のみ表示される。
 */
const ReservationPreview: React.FC = () => <PublicReservation isPreview />;

export default ReservationPreview;
